import React from 'react'
import { Box, Flex } from '@chakra-ui/react'
import { ProductCategory } from '@leid/api-products'
import Image from 'next/image'
import Link from 'next/link'

import { getCategoryURL } from 'components/nav/CategoriesMenu/utils/categories'
import theme from 'styles/theme'

import { UICategory } from './HeroCategoryBoxProd'

type CategoryCardProps = {
  cat: UICategory
  categories: ProductCategory[]
  selectedCategory?: number
  handleCategoryBoxClick: (id: number, url: string, e: React.MouseEvent) => void
}

const CategoryCard: React.FC<CategoryCardProps> = ({ cat, categories, selectedCategory, handleCategoryBoxClick }) => {
  const url = getCategoryURL(categories.find((c) => c.id === cat.id)!, categories)

  return (
    <Link key={cat.id} href={url} onClick={(e) => handleCategoryBoxClick(cat.id, url, e)} style={{ display: 'block' }}>
      <Box
        display="flex"
        flexDirection="column"
        height={{
          base: '400px',
          md: cat.size === 'Large' ? '400px' : '240px',
        }}
        backgroundColor={
          selectedCategory === cat.id
            ? theme.token.var('colors.green.a150')
            : cat.backgroundColor || theme.token.var('colors.green.a50')
        }
        p="12px"
        borderRadius="8px"
        alignItems="center"
        justifyContent="start"
        _hover={{ boxShadow: 'md', cursor: 'pointer' }}
      >
        <Box fontWeight="bold" fontSize="lg" mb="8px" textAlign="center">
          {cat.name}
        </Box>
        <Box fontSize="sm" color="gray.600" textAlign="center">
          {cat.description}
        </Box>
        {cat.imageUrl && (
          <Flex flex="1" align="center" justify="center" mt="8px" position="relative">
            <Box
              position="absolute"
              zIndex={0}
              width={{
                base: '130px',
                md: cat.size === 'Small' ? '130px' : '160px',
                lg: cat.size === 'Small' ? '130px' : '160px',
              }}
              height={{
                base: '130px',
                md: cat.size === 'Small' ? '130px' : '160px',
                lg: cat.size === 'Small' ? '130px' : '160px',
              }}
              borderRadius="50%"
              background="white"
              top="48%"
              left="48%"
              transform="translate(-50%, -50%)"
            />
            <Box position="relative" zIndex={1}>
              <Image
                src={cat.imageUrl}
                alt={cat.name}
                width={0}
                height={0}
                sizes="100vw"
                style={{
                  objectFit: 'contain',
                  width: '100%',
                  height: 'auto',
                  maxWidth: cat.size === 'Small' ? undefined : undefined,
                  maxHeight: '250px',
                }}
              />
            </Box>
          </Flex>
        )}
      </Box>
    </Link>
  )
}

export default CategoryCard
